import { useCallback, useEffect, useRef } from "react"

export const useEngine = (active: boolean) => {
  const engine = useRef<Worker | null>(null)

  useEffect(() => {
    if (active) {
      engine.current = new Worker("/stockfish-nnue-16-single.js")
    }

    return () => {
      if (engine.current) {
        engine.current.terminate()
        engine.current = null
      }
    }
  }, [active])

  /**
   * Add `onmessage` handler to the engine. (The engine emits output
   * by posting a message; we need to set `onmessage` handler to receive it.)
   */
  const setHandler = useCallback((handler: (event: MessageEvent) => void) => {
    if (engine.current) {
      engine.current.onmessage = handler
    }
  }, [])

  /** Send a UCI command to Stockfish. */
  const command = useCallback((command: string) => {
    if (engine.current) {
      engine.current.postMessage(command)
    }
  }, [])

  return { setHandler, command }
}
